import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'

/** Billet électronique d'UN voyage, côté voyageur : un billet par PNR. */
export const useDownloadMyTripETicketPdfMutation = () =>
  useMutation({
    mutationFn: async ({ bookingId, tripId }: { bookingId: string; tripId: string }) => {
      const response = await apiClient.client.get<Blob>(
        `/me/bookings/${bookingId}/trips/${tripId}/e-ticket-pdf`,
        { responseType: 'blob' }
      )
      return response.data
    },
  })
